export const images = [
"https://i.ibb.co/RChR7w6/RKJ-1187.jpg",
"https://i.ibb.co/1sH51mg/RKJ-1170.jpg",
"https://i.ibb.co/p2xzqMF/RKJ-1155.jpg",
"https://i.ibb.co/vmqtDv7/RKJ-1136.jpg",
"https://i.ibb.co/tpmPt2m/RKJ-1065.jpg",
"https://i.ibb.co/68nd6WP/RKJ-1060.jpg",
"https://i.ibb.co/0MZGjfV/RKJ-1045.jpg",
  ];
  